<template>
  <header class="header-global">
    <base-nav class="navbar-main p-1" transparent type="primary" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
				Michael O'Connell
			</router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <a href="../index.html">
            Michael O'Connell
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <span
            class="nav-link"
            v-scroll-to="'#projects'"
          >
            <span class="nav-link-inner--text">Projects</span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link"
            v-scroll-to="'#workexperience'"
          >
            <span class="nav-link-inner--text">Work Experience</span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link"
            v-scroll-to="'#skills'"
          >
            <span class="nav-link-inner--text">Skills</span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link"
            v-scroll-to="'#aboutme'"
          >
            <span class="nav-link-inner--text">About Me</span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link"
            v-scroll-to="'#contact'"
          >
            <span class="nav-link-inner--text">Contact Me</span>
          </span>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton
  }
};
</script>
<style>
</style>
